class IframeCalculator {
  constructor() {
    this.selectors = {
      iframe: 'loan-calculator-obj',
    };

    this.iframe = document.getElementById(this.selectors.iframe);
    if (!this.iframe) {
      return;
    }

    const resizeIframe = (iframe) => {
      // eslint-disable-next-line no-param-reassign
      iframe.style.height = null;
      // eslint-disable-next-line no-param-reassign
      iframe.style.height = `${iframe.contentWindow.document.documentElement.scrollHeight}px`;
    };
    window.addEventListener('resize', () => resizeIframe(this.iframe));
    this.iframe.addEventListener('load', () => resizeIframe(this.iframe));
  }
}

export default new IframeCalculator();
